import React, { useEffect, useRef, useState } from "react";
import { useUsermaven } from "@usermaven/react";

interface MARKProps {
  onExit: (to: string) => void;
}

interface AXISXY {
  x: {
    pos: number;
    value: number;
  };
  y: {
    pos: number;
    value: number;
  };
}

const MARK: React.FC<MARKProps> = ({ onExit }) => {
  const { track } = useUsermaven();

    const video = useRef<HTMLVideoElement>(null);
  
    const MURANO = useRef<HTMLDivElement>(null);
    // const ESMO = useRef<HTMLDivElement>(null);
  
    const [timeStamp, setTimeStamp] = useState<number | null>(null);
    const [animType, setanimType] = useState<string>("");
  
    const setAxis = ({ name, position }: { name: 'MURANO'; position: AXISXY }): void => {
      const refMap = {
        MURANO,
        // ESMO,
      };
  
      const element = refMap[name]?.current;
  
      if (!element) return;
  
      element.style.top = `${position.y.pos}%`;
      element.style.left = `${position.x.pos}%`;
      element.style.width = `${position.x.value}px`;
      element.style.height = `${position.y.value}px`;
    }
  
    switch (animType) {
      case "INTRO":
        setAxis({ name: "MURANO", position: { x: { pos: 46, value: 620 }, y: { pos: 40, value: 250 } } });
        // setAxis({ name: "ESMO", position: { x: { pos: 42, value: 800 }, y: { pos: 63.5, value: 100 } } });
        break;
      case "TIMELINE":
        setAxis({ name: "MURANO", position: { x: { pos: 66.3, value: 190 }, y: { pos: 5.5, value: 60 } } });
        // setAxis({ name: "ESMO", position: { x: { pos: 76.6, value: 185 }, y: { pos: 5.5, value: 60 } } });
        break;
      default:
        break;
    }
  
  
    useEffect(() => {
      track("Case Jeremy");
    }, []);
  
    useEffect(() => {
      console.log('timeStamp', timeStamp);
  
      if (timeStamp === null) return;
  
      if(timeStamp >= 9 && timeStamp <= 15)
        setanimType("INTRO");
      else if (timeStamp > 15)
        setanimType("TIMELINE");
  
    }, [timeStamp])
    
    const transitionTo = (to: number) => {
      if (video.current) {
        return video.current.currentTime = to;
      }
    }

  useEffect(() => {
    track("Case Mark");
  }, []);

  const transitionBack = () => {
    onExit("/menu");
  };

  return (
    <div id="profile_mark" className="h-screen w-screen">
      <div
        className="w-40 h-40 absolute left-0 top-0 z-10"
        onClick={() => transitionBack()}
      ></div>

      <div ref={MURANO} onClick={() => transitionTo(18.75)} className={`fixed bg-red-500 opacity-0 z-20`}></div>
      {/* <div ref={ESMO} onClick={() => transitionTo(38.2)} className={`fixed bg-green-500 opacity-0 z-20`}></div> */}

      <video
        className="h-full w-full object-cover"
        autoPlay
        playsInline
        muted
        // controls
        onTimeUpdate={(event: any) => {
          setTimeStamp(Math.round(event.target.currentTime));
        }}
        onEnded={() => transitionBack()}
        ref={video}
      >
        <source src="../assets/profiles/mark_content.mp4?v=2" />
      </video>
    </div>
  );
};

export default MARK;
